/**
 * Razor Fintech Trading API
 *
 * Contact: api@razorsedge.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * De-risking status
 */
export enum DeRiskingStatus {

    Pending = 'pending',

    InProgress = 'in_progress',

    Completed = 'completed',

    PartiallyCompleted = 'partially_completed',

    Failed = 'failed',

    Overridden = 'overridden',

    Cancelled = 'cancelled'
}
